// Shared constants for the "Thinker" marker — a team's single non-running
// member. Purely cosmetic: a tiny asterisk next to their name plus a legend.
export const THINKER_MARK = "*";
export const THINKER_LABEL = "Thinker — non-running team member";

interface ThinkerLike {
  name: string;
  isThinker?: boolean;
}

/** Comma-joined member names, each with the thinker mark when applicable. */
export function joinMemberNames(members: ThinkerLike[]): string {
  return members
    .map((m) => (m.isThinker ? `${m.name}${THINKER_MARK}` : m.name))
    .join(", ");
}
